import { SharedPagedRequest } from "@sharedcommon/model/shared-page-request.model";

export class AnalysisOriginFilterDto extends SharedPagedRequest {
  /** the code to search (in mode defined in TextMatchMode present in paged request) */
  code: string;
  /** the label to search (in mode defined in TextMatchMode present in paged request) */
  label: string;
  /** At true if you want to exclude the analysis origin which are for nutrient only */
  excludeForNutrientOnly: boolean;
  /* To test if the analysis code is included in the list */
  inCodes: string;
}